import { render, staticRenderFns } from "./OrderPartsDescriptionV2.vue?vue&type=template&id=366631ba&scoped=true"
import script from "./OrderPartsDescriptionV2.vue?vue&type=script&lang=js"
export * from "./OrderPartsDescriptionV2.vue?vue&type=script&lang=js"
import style0 from "./OrderPartsDescriptionV2.vue?vue&type=style&index=0&id=366631ba&prod&lang=css"
import style1 from "./OrderPartsDescriptionV2.vue?vue&type=style&index=1&id=366631ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366631ba",
  null
  
)

export default component.exports